/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import './DateInputPicker.css'
import {Spanish} from 'flatpickr/dist/l10n/es.js'
import { FormikProps } from 'formik'
import Flatpickr from 'react-flatpickr'
import {get} from 'lodash'
import classNames from 'classnames'

interface Props {
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  formik: FormikProps<any>
  fieldName?: string
  minDateEnable?: boolean
  minDate?: string
  maxDateEnable?: boolean
  maxDate?: string
  selectOnClickHandler?: (Date) => void
}

export const DateTimeInputPicker: FC<Props> = ({
  label,
  placeholder,
  required,
  disabled,
  formik,
  fieldName,
  minDateEnable = false,
  minDate = 'today',
  maxDateEnable = false,
  maxDate,
  selectOnClickHandler,
}: Props) => {
  const intl = useIntl()
  const options = {
    enableTime: true,
    dateFormat: 'Y-m-d H:i',
    locale: intl.formatMessage({id: 'I18N.LOCALE'}) === 'es' ? Spanish : undefined,
    monthSelectorType: 'static',
    clickOpens: !formik.isSubmitting,
  }

  if (minDateEnable && minDate) {
    options['minDate'] = minDate
  }
  if (maxDateEnable && maxDate) {
    options['maxDate'] = maxDate
  }

  return (
    <>
      <div className='row mb-2'>
        <label className='d-flex flex-column-auto flex-start align-items-start col-xxl-3 fs-6 col-form-label col-form-label-sm'>
          <span className={classNames('text-gray-700', {required: required})}>{label}</span>
        </label>

        <div className='col-xxl-9'>
          <Flatpickr
            className='form-control form-control-sm form-control-solid px-5 py-0 fs-6 text-dark'
            value={get(formik.values, `${fieldName}`) ?? ''}
            placeholder={placeholder}
            options={options}
            onChange={([date]) => {
              if (!date) {
                formik && formik.setFieldValue(`${fieldName}`, '')
                return
              }
              const noTimezoneDate = new Date(date.valueOf())
              formik && formik.setFieldValue(`${fieldName}`, noTimezoneDate)
              selectOnClickHandler && selectOnClickHandler(noTimezoneDate)
            }}
          />
          <div className='d-flex flex-row p-1'>
            <div className='d-flex flex-column flex-row-fluid'>
              <div className='d-flex flex-row flex-column-fluid'>
                <div className='d-flex flex-row-fluid flex-start'>
                  {get(formik.touched, `${fieldName}`) && get(formik.errors, `${fieldName}`) && (
                    <span className='fs-8 text-danger'>
                      {get(formik.errors, `${fieldName}`)?.toUpperCase() ?? ''}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
